import {
  JobPositionGeneralInfo as JobPositionGeneralInfoCard,
  Typography,
  UserTypeEnum,
} from "@cpj-ai/panel-npm-package";
import { useGetJobPositionByIdQuery } from "@graphql/generated";
import { Spinner } from "@heroui/react";
import { useParams } from "react-router-dom";

const PositionDetailAndCompanyDetail = () => {
  const { id } = useParams();

  const { data, loading } = useGetJobPositionByIdQuery({
    variables: {
      id: id || "",
    },
    skip: !id,
  });

  const jobPosition = data?.organization?.jobPosition?.get;

  if (loading) return <Spinner size="sm" className="my-5" />;

  return (
    <div className="flex flex-col gap-2">
      <JobPositionGeneralInfoCard jobPosition={jobPosition} userType={UserTypeEnum.ORG} />
      <Typography className="text-sm">{jobPosition?.description}</Typography>
    </div>
  );
};

export default PositionDetailAndCompanyDetail;
